// extracted by mini-css-extract-plugin
module.exports = {"iframeWrap":"ElementWistiaVideo_iframeWrap__XvGD3","wistiaEmbed":"ElementWistiaVideo_wistiaEmbed__2L1PU"};